











































import { Component } from "vue-property-decorator";
import OtherV3 from "./OtherV3.vue";

@Component
export default class OtherV4 extends OtherV3 {
  // 登録時に、disabledの項目は0にする
  public clearDisableItemV4() {
    //同一日3人以上
    if (this.disableCheckThreePersonFlg()) {
      this.receiptVisitRecord.three_person_flg = 0;
    }
    // 同一建物区分
    if (this.disableCheckSameBuildingDiv()) {
      this.receiptVisitRecord.same_building_div = 0;
    } else if (this.receiptVisitRecord.same_building_div < 3) {
      // 同一日3人以上ONで1人・2人のままの場合は、表示と合わせて「3人以上9人以下」とする
      this.receiptVisitRecord.same_building_div = 3;
    }
    //加算のみ
    if (this.disableCheckAddOnlyFlg()) {
      this.receiptVisitRecord.add_only_flg = 0;
    }
    //訪問看護感染症対策実施加算
    if (this.disableCheckCovid19Div()) {
      this.receiptVisitRecord.covid19_div = 0;
    }
  }


  protected get sameBuildingDivModel(): number {
    return this.receiptVisitRecord.same_building_div < 3
      ? 3
      : this.receiptVisitRecord.same_building_div;
  }
  
  protected set sameBuildingDivModel(value: number) {
    this.receiptVisitRecord.same_building_div = value;
  }

  // 同一建物区分
  protected disableCheckSameBuildingDiv(): boolean {
    let result = false;
    if (
      this.baseDisableCheck() ||
      this.receiptVisitRecord.three_person_flg != 1 ||
      (this.event.visit_record.mental_div == 1 &&
        this.receiptVisitRecord.remedy_div != 2) ||
      (this.event.visit_record.mental_div == 2 &&
        this.receiptVisitRecord.remedy_div != 3)
    ) {
      result = true;
    }
    return result;
  }
}
